import { useEffect, useRef } from 'react';

interface IProps {
  callback: (() => void) | (() => Promise<void>);
  value: any;
  delay: number;
}

export const useDebouncedEffect = ({ callback, value, delay }: IProps) => {
  // eslint-disable-next-line no-undef
  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      const result = callback();

      if (result instanceof Promise) {
        result.catch((err) => {
          // eslint-disable-next-line no-console
          console.error('useDebouncedEffect async callback error:', err);
        });
      }
    }, delay);

    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [value, delay]);
};
